import { IPSeparator, IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import GenericModal from 'components/Dialogs/GenericModal';
import {
  globalStackStylesResourcePanel,
  globalStackTokensGapExtraSmall,
  globalStackTokensGapMedium,
  globalTextStylesBold,
} from 'globalStyles';
import { ResourceListType } from 'models/resourceList';
import { ReactNode, useState } from 'react';
import { ILinkPreviewProps, LinkPreview } from './LinkPreview';

export interface ILinkPreviewModalProps extends ILinkPreviewProps {
  isOpen: boolean;
  onClose: () => void; //override and make mandatory
  // a second column beside the document, such as the audit task recorded on it; the modal owns
  // the column's width, separator and padding
  sidePane?: ReactNode;
  sidePaneTitle?: string;
}

// the width of an open ResourcePanel, so a side pane looks like it does in an entity scene
const sidePaneWidth = 500;

const LinkPreviewModal = (props: ILinkPreviewModalProps) => {
  const { sidePane, sidePaneTitle, ...previewProps } = props;
  const [isDocumentEditorOpen, setIsDocumentEditorOpen] = useState<boolean>(false);

  if (!props.link) return null;

  // a document's own header is hidden: the modal title shows the name, and the header would not
  // scroll with the content
  const preview = (
    <LinkPreview
      {...previewProps}
      hideHeader={props.link.list?.listType === ResourceListType.DocumentLibrary}
      onDocumentEditorOpenChange={setIsDocumentEditorOpen}
    />
  );

  return (
    <GenericModal
      title={props.link.linkName}
      isOpen={props.isOpen}
      onClose={props.onClose}
      minHeight={300}
      minWidth={200}
      height={'90vh'}
      width={'90vw'}
      maxWidth={'90vw'}
      maxHeight={'90vh'}
      hideFooter={true}
      verticalGap={globalStackTokensGapExtraSmall}
      focusTrapZoneProps={isDocumentEditorOpen ? { disabled: true } : undefined}
    >
      <IPStack verticalFill>
        <IPSeparator />
        <IPStack.Item grow styles={sidePane ? { root: { minHeight: 0 } } : undefined}>
          {sidePane ? (
            <IPStack horizontal verticalFill styles={{ root: { minHeight: 0 } }}>
              <IPStack.Item grow styles={{ root: { minWidth: 0, minHeight: 0 } }}>{preview}</IPStack.Item>
              <IPSeparator vertical />
              <IPStack.Item
                disableShrink
                styles={{ root: { width: sidePaneWidth, minHeight: 0, position: 'relative' } }}
              >
                <IPStack verticalFill styles={globalStackStylesResourcePanel} tokens={globalStackTokensGapMedium}>
                  {sidePaneTitle && (
                    <IPStack.Item>
                      <IPText styles={globalTextStylesBold} variant="large">
                        {sidePaneTitle}
                      </IPText>
                    </IPStack.Item>
                  )}
                  <IPStack.Item grow styles={{ root: { minHeight: 0, position: 'relative' } }}>
                    <IPStack verticalFill styles={{ root: { minHeight: 0, overflow: 'hidden' } }}>
                      {sidePane}
                    </IPStack>
                  </IPStack.Item>
                </IPStack>
              </IPStack.Item>
            </IPStack>
          ) : (
            preview
          )}
        </IPStack.Item>
      </IPStack>
    </GenericModal>
  );
};

export default LinkPreviewModal;
